import {
    RaikoBaseCardContainer,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoSectionContainer, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {GameStageStatusTypes} from "./GameStageStatusTypes";
import {GameStageService} from "../../../serverService/gameService/GameStageService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function GameStageStatus({gameStageId}) {

    const [actionButtonLoading, setActionButtonLoading] = useState(false);

    const [gameStageStatus, setGameStageStatus] = useState(GameStageStatusTypes.DRAFT.id)

    const service = new GameStageService();

    const loading = new LoadingHelper(useLoadingDispatcher())


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameStageStatusFromServer()
        }
    }, [gameStageId]);

    function getGameStageStatusFromServer() {
        loading.show()
        service.getGameStageStatus(gameStageId)
            .then(response => {
                setGameStageStatus(response.status)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateGameStageStaus() {
        setActionButtonLoading(true)
        service.updateGameStageStatus(gameStageId, gameStageStatus)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"وضعیت"}
                hasActionButton
                actionButtonLoadingState={actionButtonLoading}
                actionButtonOnclick={handleUpdateGameStageStaus}
            >
                <RaikoCustomSelect
                    labelText={"وضعیت"}
                    value={gameStageStatus}
                    setValue={setGameStageStatus}
                    items={[
                        raikoCustomSelectItemGenerator(GameStageStatusTypes.ACTIVE.id, GameStageStatusTypes.ACTIVE.title),
                        raikoCustomSelectItemGenerator(GameStageStatusTypes.INACTIVE.id, GameStageStatusTypes.INACTIVE.title),
                        raikoCustomSelectItemGenerator(GameStageStatusTypes.DRAFT.id, GameStageStatusTypes.DRAFT.title),
                        raikoCustomSelectItemGenerator(GameStageStatusTypes.ARCHIVED.id, GameStageStatusTypes.ARCHIVED.title),
                    ]}
                />
            </RaikoSectionContainer>

        </RaikoBaseCardContainer>
    )
}